import React from 'react';
import FileIcon from 'assets/icons/file.svg';
import { Text, Title } from 'components/Texts';
import { PrimaryWhiteA } from 'components/Buttons/Hollow';
import {
  Box, Divider, Grid, styled,
} from '@material-ui/core';
import { documentType } from 'types/documentsProject';

export default function ProjectDocuments({ documents, isDesktop }) {
  return (
    <Grid container>
      <Title
        size={16}
        mt={isDesktop ? 0 : 20}
        mb={isDesktop ? 60 : 16}
        isCenter
      >
        Documentos
      </Title>
      <ItemContainer
        item
        container
        isDesktop={isDesktop}
        pr={isDesktop && '50px'}
        pb={!isDesktop && '40px'}
      >
        {documents.slice(0, 4).map((document) => (
          <>
            {document.fileType !== 'AUTHORIZATION_CERTIFICATE' && (
              <DocumentItem alignRight isDesktop={isDesktop} {...document} />
            )}
          </>
        ))}
      </ItemContainer>
      <Divider orientation="vertical" variant="middle" flexItem />
      <ItemContainer
        item
        container
        isDesktop={isDesktop}
        pl={isDesktop && '50px'}
      >
        {documents.slice(4).map((document) => (
          <>
            {document.fileType !== 'AUTHORIZATION_CERTIFICATE' && (
              <DocumentItem isDesktop={isDesktop} {...document} />
            )}
          </>
        ))}
      </ItemContainer>
    </Grid>
  );
}

const DocumentItem = ({
  file, fileType, isDesktop, alignRight,
}) => (
  <DocumentItemContainer
    item
    container
    key={fileType}
    alignItems="center"
    alignRight={alignRight}
    justify={alignRight && 'flex-end'}
  >
    <Box width="16px" height="16px" src={FileIcon} component="img" />
    <Text
      ml={10}
      mr={10}
      width={isDesktop ? '224px' : 'calc(100% - 106px)'}
      size={isDesktop ? 14 : 15}
    >
      {documentType[fileType]}
    </Text>
    <PrimaryWhiteA
      href={file}
      target="_blank"
      padding="10px 20px"
      rel="noopener noreferrer"
    >
      Ver
    </PrimaryWhiteA>
  </DocumentItemContainer>
);

const ItemContainer = styled(Grid)((props) => ({
  paddingLeft: props.pl,
  paddingRight: props.pr,
  paddingBottom: props.pb,
  alignContent: 'baseline',
  rowGap: props.isDesktop ? '30px' : '40px',
  width: props.isDesktop ? 'calc(50% - 16.5px)' : '100%',
}));

const DocumentItemContainer = styled(Grid)({
  height: 'fit-content',
});
